import { useState } from 'react';
import { Tag } from 'shared/icons';
import Button from '../../ui/Button';
import { useToast } from '../../ui/Toast';
import KitLabelPanel from './KitLabelPanel';
import { GetLotOutputKitLabel } from './productionApi';
import { useProductionLabels } from './productionLabels';

/**
 * REIMPRESSÃO da etiqueta do kit (pedido do dono: "Pode criar a reimpressão.").
 *
 * ── O problema que ela resolve ──────────────────────────────────────────────
 * O ZPL do kit só existia na RESPOSTA do apontamento: fechou a aba, perdeu a
 * etiqueta — e caixa sem etiqueta é caixa sem lote, o oposto do que o M6 existe
 * para fazer. Aqui a segunda via é buscada pelo APONTAMENTO
 * (`/lot-outputs/:id/kit-label`), que o backend reconstrói a partir do que foi
 * gravado: produto, LT, quantidade e nº de kits. Ela é IGUAL à primeira porque
 * sai do mesmo dado e do mesmo gerador — não existe um segundo motor de
 * etiqueta no sistema (regra 10).
 *
 * ── Por que carrega sob demanda ─────────────────────────────────────────────
 * Uma lista de saídas pode ter dezenas de linhas; gerar o ZPL de todas para
 * imprimir uma seria trabalho jogado fora. O botão busca a etiqueta daquele
 * apontamento e entrega ao `KitLabelPanel` — o MESMO painel da bancada, com o
 * mesmo seletor de impressora (rede cadastrada + USB desta máquina via QZ).
 */
const KitLabelReprint = ({ output }) => {
    const { label } = useProductionLabels();
    const toast = useToast();
    const [kitLabel, setKitLabel] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleLoad = async () => {
        if (!output?.id) {
            return;
        }
        setLoading(true);
        try {
            const data = await GetLotOutputKitLabel(output.id);
            setKitLabel(data?.kit_label ?? null);
        } catch (error) {
            toast.error(error?.message || label('wms.common.load_error'));
        } finally {
            setLoading(false);
        }
    };

    if (kitLabel) {
        return (
            <div className="mt-2">
                <KitLabelPanel label={label} kitLabel={kitLabel} fileName={output?.production_lot_code || output?.id} />
            </div>
        );
    }

    return (
        <Button
            type="button"
            variant="ghost"
            size="sm"
            className="mt-1"
            onClick={handleLoad}
            loading={loading}
            title={label('wms.production.reprint_hint')}
        >
            <Tag size={14} className="mr-1.5" />
            {label('wms.action.reprint_kit_label')}
        </Button>
    );
};

export default KitLabelReprint;
